module.exports = __webpack_public_path__ + "img/cosmomo-thumbnail.21e4ab34.png";